var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('van-swipe',{attrs:{"loop":false,"indicator-color":"white"}},[_c('van-swipe-item',[_c('img',{attrs:{"src":require("@/assect/Welcome3.png")}}),_c('h5',{staticClass:"exper"},[_c('span',{staticClass:"experience",on:{"click":_vm.enter}},[_vm._v("立即体验")])])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }